// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3l6_z","label":"styles_label__1qFXS"};